import React, { useState, useRef } from 'react';
import { api } from '../api/client';

interface FileAttachmentProps {
  onAttachmentChange: (attachment: { type: string; token: string } | null) => void;
}

export const FileAttachment: React.FC<FileAttachmentProps> = ({ onAttachmentChange }) => {
  const [file, setFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const [token, setToken] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileSelect = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0];
    if (!selectedFile) return;

    if (selectedFile.size > 5 * 1024 * 1024) {
      setError('Файл слишком большой (макс. 5 МБ)');
      return;
    }

    setFile(selectedFile);
    setUploading(true);
    setError(null);

    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      const response = await api.post('/admin/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setToken(response.data.token);
      setUploaded(true);
      onAttachmentChange({ type: response.data.type || 'file', token: response.data.token });
    } catch (err) {
      setError('Не удалось загрузить файл');
      setFile(null);
      onAttachmentChange(null);
    } finally {
      setUploading(false);
    }
  };

  const handleRemoveFile = () => {
    setFile(null);
    setUploaded(false);
    setToken(null);
    setError(null);
    onAttachmentChange(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const formatSize = (bytes: number) => {
    if (bytes < 1024) return `${bytes} Б`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} КБ`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} МБ`;
  };

  return (
    <div style={{ marginBottom: 12 }}>
      {!file && (
        <button
          onClick={() => fileInputRef.current?.click()}
          style={{
            padding: '6px 12px',
            cursor: 'pointer',
            border: '1px solid #ddd',
            borderRadius: 4,
            background: '#f9f9f9',
            fontSize: 14,
          }}
        >
          📎 Прикрепить файл (до 5 МБ)
        </button>
      )}
      <input
        ref={fileInputRef}
        type="file"
        onChange={handleFileSelect}
        style={{ display: 'none' }}
      />

      {file && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '4px 8px',
          border: '1px solid #ddd',
          borderRadius: 4,
          background: '#fafafa',
          fontSize: 14,
        }}>
          <span>📄 {file.name}</span>
          <span style={{ color: '#999' }}>({formatSize(file.size)})</span>
          {uploading && <span style={{ color: '#007AFF' }}>⏳ Загрузка...</span>}
          {uploaded && <span style={{ color: '#4CAF50' }}>✅ Готово</span>}
          {error && <span style={{ color: '#ff4444' }}>❌ {error}</span>}
          <button
            onClick={handleRemoveFile}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: '#ff4444',
              fontSize: 16,
              padding: '0 4px',
            }}
            title="Удалить файл"
          >
            ✕
          </button>
        </div>
      )}
    </div>
  );
};